import React from 'react';

const TipsPassword = (
  <div>
    密碼必須符合以下規則 <br />
    &nbsp;&nbsp; 1.密碼長度至少為8碼。 <br />
    &nbsp;&nbsp; 2.密碼內容包含以下字元： <br />
    &nbsp;&nbsp;&nbsp;&nbsp; (1)英文大寫字元(A到Z) 。<br />
    &nbsp;&nbsp;&nbsp;&nbsp; (2)英文小寫字元(a到z) 。 <br />
    &nbsp;&nbsp;&nbsp;&nbsp; (3)10進位數字(0到9) 。
  </div>
);

export default TipsPassword;
